import React, { createContext, ReactNode, useReducer } from 'react';

import { NewsItem } from '../pages/Home/types';

type ActionType = {
  type: 'SET_ARTICLE';
  payload: NewsItem | null;
};

interface ArticleProviderProps {
  children: ReactNode;
}

const initialState = null;

const reducer = (state: NewsItem | null, action: ActionType) => {
  switch (action.type) {
    case 'SET_ARTICLE':
      return action.payload;
    default:
      return state;
  }
};

export const SelectedNewsContext = createContext<{
  selectedArticle: NewsItem | null;
  setSelectedArticle: (article: NewsItem | null) => void;
}>({
  selectedArticle: null,
  setSelectedArticle: () => {},
});

export const ArticleProvider: React.FC<ArticleProviderProps> = ({
  children,
}) => {
  const [selectedArticle, dispatch] = useReducer(reducer, initialState);

  const setSelectedArticle = (article: NewsItem | null) =>
    dispatch({ type: 'SET_ARTICLE', payload: article });

  return (
    <SelectedNewsContext.Provider
      value={{ selectedArticle, setSelectedArticle }}
    >
      {children}
    </SelectedNewsContext.Provider>
  );
};
